module.exports = __webpack_public_path__ + "static/media/40x40-4.eebbc1ff.png";